// src/components/FAQ.js
import React from 'react';

const VentraChatbot = () => {
    return (
        <div>
            <h2>Ventra, your own AI chatbot.</h2>
            {/* Content for FAQ */}
            <p>Coming soon.</p>
        </div>
    );
};

export default VentraChatbot;
